import { render, staticRenderFns } from "./ProductManagementByArticle.vue?vue&type=template&id=6ed9631c&scoped=true"
import script from "./ProductManagementByArticle.vue?vue&type=script&lang=js"
export * from "./ProductManagementByArticle.vue?vue&type=script&lang=js"
import style0 from "./ProductManagementByArticle.vue?vue&type=style&index=0&id=6ed9631c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed9631c",
  null
  
)

export default component.exports